import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { pt } from "date-fns/locale";

export const fmtDia = (d) => (d ? d.split("-").reverse().slice(0, 2).join("/") : "");
const hojeISO = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Lisbon" });
const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const PEND = ["aguarda_fornecedor", "em_transito"];

export const PrazoLinha = ({ linha, fornecedor, onSave }) => {
  const [open, setOpen] = useState(false);
  const opcoes = fornecedor?.prazos || [];
  const atrasada = linha.data_prevista && linha.data_prevista < hojeISO() && PEND.includes(linha.estado);
  const chegou = linha.chegou_at && PEND.includes(linha.estado);
  const guardar = (p) => { onSave(p); setOpen(false); };
  const sel = linha.data_prevista ? new Date(`${linha.data_prevista}T12:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`linha-prevista-${linha.id}`} title={chegou ? "Chegou · pronto a recolher" : linha.prevista_assumida ? "Assumido: dia seguinte (sem prazo definido) — clique para confirmar" : "Chegada prevista"}
          className={`text-[11px] px-1 py-0.5 rounded hover:bg-slate-100 tabular-nums ${chegou ? "text-emerald-700 font-semibold" : atrasada ? "text-rose-600 font-semibold" : "text-slate-600"}`}>
          <span className={linha.prevista_assumida && !chegou ? "italic text-slate-500" : ""}>{fmtDia(linha.data_prevista) || "—"}{linha.prevista_assumida && !chegou ? "*" : ""}</span>{chegou ? " ✓" : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align="end">
        {opcoes.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-2" data-testid={`linha-prazos-${linha.id}`}>
            {opcoes.map((p, i) => (
              <button key={`${p.nome}-${p.dias}`} type="button" onClick={() => guardar({ prazo_dias: p.dias })} data-testid={`linha-prazo-${linha.id}-${i}`}
                className={`text-[11px] border rounded-full px-2 py-0.5 hover:border-blue-400 ${linha.prazo_dias === p.dias ? "bg-blue-50 border-blue-300" : "border-slate-200"}`}>
                {p.nome} · {p.dias} d
              </button>
            ))}
          </div>
        )}
        <Calendar mode="single" locale={pt} weekStartsOn={1} selected={sel} defaultMonth={sel} onSelect={(d) => guardar({ data_prevista: d ? toISO(d) : linha.data_prevista })} data-testid={`linha-calendario-${linha.id}`} />
        {linha.prevista_assumida && linha.data_prevista && (
          <button type="button" className="block text-[11px] text-blue-600 hover:underline mt-1" onClick={() => guardar({ data_prevista: linha.data_prevista })} data-testid={`linha-prevista-confirmar-${linha.id}`}>Confirmar {fmtDia(linha.data_prevista)}</button>
        )}
        {linha.data_prevista && (
          <button type="button" className="text-[11px] text-slate-500 hover:text-rose-600 mt-1" onClick={() => guardar({ data_prevista: null })} data-testid={`linha-prevista-limpar-${linha.id}`}>Limpar data</button>
        )}
      </PopoverContent>
    </Popover>
  );
};
